export default __webpack_public_path__ + "c0ef9320b453f71e4533cef3676e9044.jpg";